import axios from 'axios';
import { BIGOTV_DOMAIN_MAP } from '@/api/config';
import { getCurrentEnv } from '@/api/request';
import { track } from '@bigo/logger';
import { isBigolive } from '@/common/utils';
import { replaceHost } from '@/libs/domainAnti';

let pendingCountryCodePromise: Promise<void> | null = null;
type envType = 'mock' | 'dev' | 'test' | 'gray' | 'prod';

const httpPhp = axios.create({
  baseURL: '',
  withCredentials: true,
  timeout: 15000, // 设置15s超时，避免请求时间过长阻碍多语言加载
});

httpPhp.interceptors.response.use(
  (response) => response.data,
  (error) => {
    return Promise.reject(error && error.response && error.response.data);
  },
);

const getStorageCountry = () => {
  const countryStorageInfo = localStorage.getItem('countryStorage');
  if (countryStorageInfo) {
    const { country, setTime } = JSON.parse(countryStorageInfo);
    return {
      country,
      setTime,
    };
  }
  return {
    country: '',
    setTime: 0,
  };
};

const reqCountryCode = async () => {
  const env = getCurrentEnv() as envType;
  const bigoTvUrl = BIGOTV_DOMAIN_MAP[env];
  const baseurl = `/official_website/usercenter/queryCountry`;
  // 线上用同域转发
  const requrl = env === 'prod' ? `/backend_api${baseurl}` : `${bigoTvUrl}${baseurl}`;
  const res = await httpPhp({
    method: 'post',
    url: requrl,
  });
  if (res.data?.country) {
    localStorage.setItem(
      'countryStorage',
      JSON.stringify({
        country: res.data.country,
        setTime: new Date().getTime(),
      }),
    );
  }
};

const getCountryCode = async () => {
  try {
    const { country, setTime } = getStorageCountry();
    const curTime = new Date().getTime();

    // 如果已有缓存且未过期，直接返回
    if (setTime && country && curTime - setTime <= 1000 * 60 * 60) {
      return country;
    }

    // 如果已有请求进行中，返回正在进行的请求
    if (pendingCountryCodePromise) {
      await pendingCountryCodePromise;
      const { country } = getStorageCountry();
      return country;
    }

    // 否则发起新的请求
    pendingCountryCodePromise = reqCountryCode().finally(() => {
      pendingCountryCodePromise = null;
    });

    await pendingCountryCodePromise;
    const { country: newCountry } = getStorageCountry();
    return newCountry;
  } catch (err: any) {
    console.log('country error', err.message);
    track({
      log_action: 'agent-country-error',
      log_content: err.message,
    });
    return '';
  }
};

export const getReplaceDomain = async (url: string) => {
  const isProd = import.meta.env.VITE_BUILD_ENV === 'prod';
  try {
    let countryCode = '';
    // 端外并且是线上才需要接口获取国家码
    if (!isBigolive && isProd) {
      countryCode = await getCountryCode();
    }
    // @ts-ignore
    if (window.doBlockHostReplace) {
      // doBlockHostReplace传参: url, baseURL, extraParams
      // @ts-ignore
      return window.doBlockHostReplace(url, '', { customCountryCode: countryCode }).url;
    }
    return replaceHost(url);
  } catch {
    return replaceHost(url);
  }
};
